module.exports = __webpack_public_path__ + "static/img/open_lottery.3128879.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/open_lottery.png
// module id = /lvU
// module chunks = 6